import React from "react"

import "./App.css"
import "./theme.css"

import * as Sentry from "@sentry/react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { LocaleContextProvider } from "context/LocaleContext"
import { Provider } from "react-redux"
import { store } from "store/store"
import { StyledComponentsProvider } from "ui/providers/styled-components"

import Home from "./Home"

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Performance Monitoring
  tracesSampleRate: 0.2, // Capture 100% of the transactions, reduce in production!
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
})

const queryClient = new QueryClient()

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <StyledComponentsProvider>
          <LocaleContextProvider locale="en">
            <Home />
          </LocaleContextProvider>
        </StyledComponentsProvider>
      </Provider>
    </QueryClientProvider>
  )
}

export default App
